import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 110 110"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  width: "110",
  height: "110",
  rx: "15",
  ry: "15",
  style: {"fill":"#f6f42e"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M30 85h12v10H30c-8.3 0-15-6.7-15-15V68h10v12c0 2.8 2.2 5 5 5m-5-55c0-2.8 2.2-5 5-5h12V15H30c-8.3 0-15 6.7-15 15v12h10zm60 50c0 2.8-2.2 5-5 5H68v10h12c8.3 0 15-6.7 15-15V68H85zm-5-65H68v10h12c2.8 0 5 2.2 5 5v12h10V30c0-8.3-6.7-15-15-15m-5.1 23.7L49.1 64.5 34.8 50.2l-7.1 7.1 21.4 21.4L82 45.8z",
  style: {"fill":"#63666a"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }